import { useState } from 'react';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import BarcodeScannerDialog from './BarcodeScannerDialog';
import type { ScanResult } from './BarcodeScannerDialog';

interface ScanIconButtonProps {
  onDetected: (value: string) => Promise<ScanResult> | void;
  mode?: 'single' | 'continuous';
  disabled?: boolean;
  tooltip?: string;
}

export default function ScanIconButton({
  onDetected,
  mode = 'single',
  disabled,
  tooltip = 'Сканувати код',
}: ScanIconButtonProps) {
  const [scannerOpen, setScannerOpen] = useState(false);

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            onClick={() => setScannerOpen(true)}
            disabled={disabled}
          >
            <PhotoCameraIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <BarcodeScannerDialog
        open={scannerOpen}
        mode={mode}
        onClose={() => setScannerOpen(false)}
        onDetected={onDetected}
      />
    </>
  );
}
